(ns app.strive-forms.component-multi-methods)

(defmulti update-question-input-local
  (fn [props]
    (:type props)))

(defmulti update-question-input-data
  (fn [props]
    (:type props)))

(defmulti calc-error-message
  (fn [props]
    (:type props)))

(defmulti show-action-btn?
  :type)

(defmethod show-action-btn? :default [_]
  false)
